export type CourseLanguageSlug = "french" | "dutch";
export type TutorDomainSurface = "exact-domain" | "chickytutor-hybrid";

export function isHybridCoursePath(pathname: string, languageSlug: string) {
  return (
    pathname === `/hybrid/${languageSlug}` ||
    (languageSlug === "dutch" && pathname === "/hybrid/dutch/from/french")
  );
}

export function getDutchInstructionLanguage(coursePageUrl: string): "English" | "French" {
  return new URL(coursePageUrl).pathname === "/hybrid/dutch" ? "English" : "French";
}

const COURSE_ATTRIBUTION = {
  french: {
    "exact-domain": {
      checkoutSource: "aifrenchtutor_homepage",
      sourceDomain: "aifrenchtutor.com",
    },
    "chickytutor-hybrid": {
      checkoutSource: "chickytutor_hybrid_french",
      sourceDomain: "chickytutor.com",
    },
  },
  dutch: {
    "exact-domain": {
      checkoutSource: "aidutchtutor_homepage",
      sourceDomain: "aidutchtutor.com",
    },
    "chickytutor-hybrid": {
      checkoutSource: "chickytutor_hybrid_dutch",
      sourceDomain: "chickytutor.com",
    },
  },
} as const;

export type CourseCheckoutSource =
  (typeof COURSE_ATTRIBUTION)[CourseLanguageSlug][TutorDomainSurface]["checkoutSource"];

export function getCourseAttribution(
  languageSlug: CourseLanguageSlug,
  surface: TutorDomainSurface
) {
  return {
    checkout_source: COURSE_ATTRIBUTION[languageSlug][surface].checkoutSource,
    course_surface: surface,
    source_domain: COURSE_ATTRIBUTION[languageSlug][surface].sourceDomain,
  } as const;
}

export function getCourseSurfaceFromPageUrl(
  coursePageUrl: string,
  languageSlug: CourseLanguageSlug
): TutorDomainSurface {
  const page = new URL(coursePageUrl);
  return isHybridCoursePath(page.pathname, languageSlug) ? "chickytutor-hybrid" : "exact-domain";
}

export function getCourseSurfaceFromCheckoutSource(
  languageSlug: CourseLanguageSlug,
  value: string | null | undefined
): TutorDomainSurface | null {
  if (value === COURSE_ATTRIBUTION[languageSlug]["exact-domain"].checkoutSource) {
    return "exact-domain";
  }
  if (value === COURSE_ATTRIBUTION[languageSlug]["chickytutor-hybrid"].checkoutSource) {
    return "chickytutor-hybrid";
  }
  return null;
}
